import React, { forwardRef } from "react";

const Card = forwardRef(({ className = "", ...props }, ref) => (
  <div ref={ref} className={`rounded-lg border bg-white text-gray-900 shadow-sm ${className}`} {...props} />
));

export default Card; 